import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import * as React from 'react';
import { useErrorMessages } from '../../../../models/hooks/appStateHooks';
import { useBackorderAreacodes } from '../../../../queries';
import { Checkbox } from '../../../../web/components/Checkbox';
import { LoadingSpinner } from '../../../../web/components/LoadingSpinner';
import { RoundAddIcon } from '../../../../web/components/svgs/icons/RoundAddIcon';
import { TextInput } from '../../../../web/components/TextInput';
import { baseStyleSheet } from '../../../../web/styles/styles';
import { styleSheet } from './styles';

interface IProps {
	impersonationContext: Api.IImpersonationContext;
	onSuccess: () => void;
}

export function BackorderAreacodesForm({ onSuccess, impersonationContext }: IProps) {
	const errorMessages = useErrorMessages();
	const [areacodes, setAreacodes] = React.useState<string[]>(['']);
	const [scope, setScope] = React.useState<'User' | 'Account'>('User');
	const mutation = useBackorderAreacodes({
		impersonationContext,
		onError: error => {
			errorMessages.pushApiError(error);
		},
		onSuccess,
	});
	const onScopeChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
		setScope(ev.target.checked ? 'Account' : 'User');
	};
	const onSave = () => {
		mutation.mutate({ areacodes, scope });
	};
	return (
		<div className={css(styleSheet.providerForm)}>
			<p className={css(styleSheet.providerFormHeader)}>Submit Backorder Request</p>
			{areacodes.map((areacode, index) => {
				return (
					<TextInput
						inputId={`areacode-${index}`}
						key={index}
						type='text'
						value={areacode}
						onChange={ev => {
							const newAreacodes = [...areacodes];
							newAreacodes[index] = ev.target.value;
							setAreacodes(newAreacodes);
						}}
					/>
				);
			})}
			<button className={css(styleSheet.backorderFormAddButton)} onClick={() => setAreacodes([...areacodes, ''])}>
				<RoundAddIcon className={css(styleSheet.backorderFormAddButtonIcon)} />
				Add area code
			</button>
			<Checkbox checked={scope === 'Account'} onChange={onScopeChange} id='backdoor-scope'>
				<span>Shared</span>
			</Checkbox>
			<button disabled={mutation.isPending} className={css(baseStyleSheet.ctaButton)} onClick={onSave}>
				{mutation.isPending ? <LoadingSpinner type='tiny' className={css(styleSheet.providerFormBtnSpinner)} /> : null}{' '}
				Submit
			</button>
		</div>
	);
}
